<template lang="pug">
.curso-main-container.pb-3
  BannerInterno
  .container.tarjeta.tarjeta--blanca.p-4.p-md-5.mb-5
    .titulo-principal.color-acento-contenido(data-aos="flip-up")
      .titulo-principal__numero
        span 1
      h1 El ser humano
    .row.justify-content-center.align-items-center.mb-4
      .col-lg-12
        figure(data-aos="zoom-in")
          img.img-fluid(src="@/assets/curso/temas/tema1/img1.png" alt="Imagen decorativa")
    p.mb-5(data-aos="fade-left") El ser humano es un ser integral y complejo, que no puede comprenderse únicamente desde lo biológico. Está conformado por las siguientes dimensiones:
    
    SlyderF.mb-5(columnas="col-lg-6 col-xl-4")
      .tarjeta.color-primario.p-4
        .row.justify-content-center.mb-3
          .col-6
            img(src='@/assets/curso/temas/tema1/img2.svg' alt='AvatarTop')
        h5.text-center Física
        p.text-center Se refiere al cuerpo y a su funcionamiento biológico, incluyendo la salud, la enfermedad, el autocuidado y las condiciones que permiten el desarrollo y la supervivencia.
      .tarjeta.color-primario.p-4
        .row.justify-content-center.mb-3
          .col-6
            img(src='@/assets/curso/temas/tema1/img3.svg' alt='AvatarTop')
        h5.text-center Psicológica
        p.text-center Comprende los procesos mentales como el pensamiento, la memoria, el aprendizaje, la percepción y la toma de decisiones, que influyen en la conducta y el bienestar personal.
      .tarjeta.color-primario.p-4
        .row.justify-content-center.mb-3
          .col-6
            img(src='@/assets/curso/temas/tema1/img4.svg' alt='AvatarTop')
        h5.text-center Social
        p.text-center Alude a la capacidad de relacionarse e interactuar con otras personas, participar en grupos y construir vínculos, roles y redes de apoyo dentro de la comunidad.
      .tarjeta.color-primario.p-4
        .row.justify-content-center.mb-3
          .col-6
            img(src='@/assets/curso/temas/tema1/img5.svg' alt='AvatarTop')
        h5.text-center Emocional
        p.text-center Hace referencia al reconocimiento, expresión y manejo de las emociones y sentimientos, fundamentales para el equilibrio personal y la calidad de las relaciones humanas.
      .tarjeta.color-primario.p-4
        .row.justify-content-center.mb-3
          .col-6
            img(src='@/assets/curso/temas/tema1/img6.svg' alt='AvatarTop')
        h5.text-center Cultural
        p.text-center Incluye valores, creencias, costumbres, tradiciones y formas de vida que orientan la manera de pensar, actuar y comprender la realidad en un contexto determinado.
      .tarjeta.color-primario.p-4
        .row.justify-content-center.mb-3
          .col-6
            img(src='@/assets/curso/temas/tema1/img7.svg' alt='AvatarTop')
        h5.text-center Espiritual
        p.text-center Se relaciona con la búsqueda de sentido, propósito y trascendencia en la vida, así como con las creencias y valores que dan significado a la existencia, independientemente de una religión específica.

    .row.justify-content-center.align-items-center.mb-5
      .col-lg-10
        .cajon.color-primario.p-4.mb-4
          p.mb-0 Estas dimensiones interactúan de manera permanente y determinan su forma de pensar, sentir, actuar y relacionarse con los demás y con su entorno.

    .row.justify-content-center.align-items-center
      .col-lg-4
        figure(data-aos="zoom-in")
          img.img-fluid(src="@/assets/curso/temas/tema1/img8.jpg" alt="Icono 1")
      .col-lg-8.mb-4.mb-lg-0
        .row.justify-content-center.mb-3
          .col-lg-2.d-none.d-lg-block
            figure(data-aos="zoom-in")
              img.img-fluid(src="@/assets/curso/temas/tema1/img9.svg" alt="Icono 1")
          .col-lg-10(data-aos="fade-left")
            p.mb-0 Desde una perspectiva humanista, el ser humano es un sujeto con dignidad, consciente de sí mismo, capaz de reflexionar, comunicarse, tomar decisiones y transformar la realidad. Vive en constante interdependencia social, construyendo vínculos, valores y significados a partir de la convivencia, la solidaridad y el respeto mutuo.
        p.mb-4 Además, el ser humano posee la capacidad de experimentar emociones, aprender de la experiencia y adaptarse al cambio, lo que le permite enfrentar desafíos individuales y colectivos. Su comportamiento está influido tanto por factores internos como por condiciones históricas, sociales y culturales que moldean su identidad.
         
        .cajon.color-secundario.p-4(data-aos="fade-left")
          p.mb-0(data-aos="fade-left")  En el ámbito de la salud, reconocer al ser humano como un todo integral, implica comprender que cada persona es única, con necesidades, expectativas y contextos propios. Esta visión es la base de la humanización en salud, ya que orienta prácticas centradas en la persona, promueve relaciones empáticas y fortalece una atención respetuosa, ética y comprometida con la vida y el bienestar. 


    separador
    #t_1_1.titulo-segundo.color-acento-contenido(data-aos="fade-left")
      h2  1.1	Contexto histórico humanismo
    p.mb-4(data-aos="fade-left") Para conocer un poco sobre el humanismo, es preciso ingresar al siguiente video, el cual contextualiza sobre este accionar:
    .row.justify-content-center.align-items-center
      .col-lg-12
        figure(data-aos="zoom-in")
          .video
            iframe(width="1401" height="788" src="https://www.youtube.com/embed/OvGtOokFbFo" title="Contexto histórico" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen)
    

    separador
    #t_1_2.titulo-segundo.color-acento-contenido(data-aos="fade-left")
      h2  1.2	Componentes del ser humano
    p.mb-0(data-aos="fade-left") Es importante resaltar la importancia del ser humano en el contexto de la atención en salud, reconociendo su condición humana integral. No solamente desde el concepto biológico; es decir, cuando se refiere a la estructura física y orgánica que compone al ser humano, si no, también, entender que los seres humanos se desenvuelven en un estado permanente de reciprocidad con el entorno, interdependencia social y complementariedad.
    .BMG1.p-4
      .row.justify-content-center.align-items-center.mb-5
        .col-lg-10(data-aos="fade-left")
          p Con las potencialidades y limitaciones, en cada uno de los seres humanos habita y actúa un poder transformador, estrechamente en estado permanente de compasión, creación y construcción individual y social de conocimientos del saber, que se expresa en sentimientos y emociones del amar; de realizaciones y productos, del hacer; de escenarios y visiones de futuro, de utopías, del soñar; y de espiritualidad y creencias, del trascender.
      .row.justify-content-center.align-items-center
        .col-lg-4
          figure(data-aos="zoom-in")
            img.img-fluid(src="@/assets/curso/temas/tema1/img10.png" alt="Icono 1")
        .col-lg-6.mb-4.mb-lg-0(data-aos="fade-left")
          .bloque-texto-b.color-primario.p-4.mb-4
            .bloque-texto-b__texto
              i.fas.fa-quote-left
              h5.mb-0 Todas las personas son co-creadoras y actores de una inacabada concepción de humano y de planeta.
              i.fas.fa-quote-right
          .row.justify-content-center.mb-3
            .col-lg-2.d-none.d-lg-block
              figure(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema1/img11.svg" alt="Icono 1")
            .col-lg-10
              p.mb-0(data-aos="fade-left") Ya sea en su calidad de sujeto individual, social, de especie o planetario, ligado en su totalidad con la naturaleza (planeta), con cada ser vivo que la compone, cada ser vivo es hermano del ser humano y el centro es la vida, de cambio constante individual y como sociedad.
          
          p.mb-0(data-aos="fade-left")  La personalidad de cada uno se basa en su naturaleza interna, biológica e innata, en parte individual y única y en común a otros individuos, destacándose entre los elementos comunes las necesidades naturales.
    .titulo.mb-4(data-aos="fade-left")
      img(src='@/assets/curso/icon.svg', alt='Imagen decorativa')
      h5 Necesidades
    p.mb-4(data-aos="fade-left") Las condiciones del ser humano están mediadas por sus necesidades básicas. El recién nacido no tiene necesariamente las mismas necesidades básicas que el adolescente o el anciano; pero, independientemente del grupo de edad de la persona, están presentes en mayor o menor medida.
    .row.justify-content-center.mb-4
      .col-lg-1.d-none.d-lg-block
        figure(data-aos="zoom-in")
          img.img-fluid(src="@/assets/curso/temas/tema1/img12.svg" alt="Icono 1")
      .col-lg-9
        p.mb-0(data-aos="fade-left") Maslow, como uno de los fundadores de las psicologías humanista y transpersonal, centra al ser humano en la autorrealización, entendida como culminación de la tendencia al crecimiento. La define como la obtención de la satisfacción de necesidades progresivamente superiores, junto a esto, la satisfacción de la necesidad de estructurar el mundo, a partir de sus propios análisis y valores. Por lo tanto, la personalidad de cada uno se basa en su naturaleza interna, biológica e innata, en parte individual, única y en común a otros individuos. Entre los elementos comunes están las necesidades naturales, explicadas por medio de la siguiente pirámide, la cual se basa en la teoría de Abraham Maslow:
    .row.justify-content-center.align-items-center.mb-3
      .col-lg-10.desktop(data-aos="fade-left")
        ImagenInfografica.color-acento-botones.mb-5
          template(v-slot:imagen)
            figure
              img(src='@/assets/curso/temas/tema1/img13.svg', alt='Texto que describa la imagen')
          .tarjeta.color-acento-botones.p-3(x="92%" y="81.5%" numero="1")
            p Entre estas se encuentran: hambre, sed, sueño, vestidos, cobijo, sexo... Pueden localizarse en lugares específicos del cuerpo humano. Se denominan también homeostáticas, porque contribuyen al equilibrio del estado corporal.
          .tarjeta.color-acento-botones.p-3(x="7%" y="67%" numero="2")
            p Surgen cuando las necesidades fisiológicas se mantienen controladas. Se relacionan a sentirse seguro y protegido: seguridad física y personal, estabilidad laboral o económica
          .tarjeta.color-acento-botones.p-3(x="84%" y="52%" numero="3")
            p Conciernen a la estima alta a la necesidad del respeto de uno mismo e incluyen sentimientos como confianza, competencia, logros independencia y libertad; la estima al respeto de las demás personas, la necesidad de atención, aprecio, reconocimiento, reputación, estatus, dignidad, etc.

          .tarjeta.color-acento-botones.p-3(x="16%" y="35.5%" numero="4")
            p Se fortalecen con el desarrollo afectivo del individuo, como asociación, participación y aceptación. Se satisfacen mediante las funciones de servicios y prestaciones como actividades deportivas, culturales, recreativas.

          .tarjeta.color-acento-botones.p-3(x="76%" y="19%" numero="5")
            p Corresponden a las necesidades de nivel más elevado, en las que las personas encuentran sentido a la vida, mediante el reconocimiento y desarrollo de sus potencialidades. Se alcanzan cuando los niveles anteriores han sido satisfechos de manera progresiva e integral.
      .col-lg-10.movil
        figure(data-aos="zoom-in")
          img.img-fluid(src="@/assets/curso/temas/tema1/img13_1.svg" alt="Icono 1")
    .row.justify-content-center.align-items-center.mb-5
      .col-lg-10(data-aos="fade-left")
        .cajon.color-secundario.p-4.mb-4
          p.mb-0 El llegar al nivel más alto, es un proceso que no se acaba, el ser humano está en evolución constante y al llegar al máximo nivel, lo motiva a la necesidad de desarrollar la capacidad de escoger, decidir y crear opciones más avanzadas.
    .titulo.mb-4(data-aos="fade-left")
      img(src='@/assets/curso/icon.svg', alt='Imagen decorativa')
      h5 Capacidades
    p.mb-4 En razón a la necesidad de desarrollar la capacidad de escoger y decidir para crear, se habla de bienestar y libertad. Diversos autores han llamado la atención sobre las capacidades y las han ponderado de forma distinta.
    .bloque-texto-g.bloque-texto-g--inverso.color-primario.p-3.p-sm-4.p-md-5.mb-4
      .bloque-texto-g__img(
        :style="{'background-image':`url(${require('@/assets/curso/temas/tema1/img14.jpg')})`}"
      )
      .bloque-texto-g__texto.p-4
        p.mb-0 Desde la teoría de las capacidades humanas de Amartya Sen, creador e impulsor del enfoque de las capacidades, quien las define como “las diversas cosas que una persona puede valorar hacer o ser” (Sen, 2000: 99, citado por Cejudo, 2006)). La capacidad es principalmente un reflejo de la libertad para alcanzar funcionamientos valiosos. En cierto modo, las capacidades se pueden entender como las circunstancias propicias en las que ciertas habilidades predisponen a lo que se quiere. Las capacidades de una persona se ven reflejadas en los funcionamientos que son su sentido. A su vez, constituyen los logros efectivos que una persona puede alcanzar y que se expresan en las diversas actividades o «estados» que puede realizar libremente.

    p.mb-4(data-aos="fade-left") El PNUD (Programa de las Naciones Unidas para el Desarrollo), establece como objetivo básico del desarrollo humano “aumentar las libertades humanas en un proceso que puede expandir las capacidades personales toda vez que amplía las alternativas disponibles para que la gente viva una vida plena y creativa” (2004). Además, según dicho programa, el ser humano dispone de una gama infinita de capacidades que deben ser valoradas universalmente. Así, el PNUD en su informe sobre desarrollo humano, establece 4 capacidades como las más importantes del ser, estas son:

    .row.mb-5
      .col-lg.col-md-6.mb-lg-0.mb-4(data-aos="fade-right")
        .tarjeta-numerada.color-primario.p-5.h-100
          .tarjeta-numerada__numero
            .h2 1
          p.text-center
          p.text-center.mb-0 Vivir una vida larga y saludable.
      .col-lg.col-md-6.mb-lg-0.mb-4(data-aos="flip-right")
        .tarjeta-numerada.color-secundario.p-5.h-100
          .tarjeta-numerada__numero
            .h2 2
          p.text-center
          p.text-center.mb-0 Disponer de educación.
      .col-lg.col-md-6.mb-lg-0.mb-4(data-aos="flip-left")
        .tarjeta-numerada.color-acento-contenido.p-5.h-100
          .tarjeta-numerada__numero
            .h2 3
          p.text-center
          p.text-center.mb-0 Tener acceso a los recursos necesarios para disfrutar de un nivel de vida digno.
      .col-lg.col-md-6.mb-lg-0.mb-4(data-aos="fade-left")
        .tarjeta-numerada.color-acento-botones.p-5.h-100
          .tarjeta-numerada__numero
            .h2 4
          p.text-center
          p.text-center.mb-0 Participar en la vida de la comunidad.

    .titulo.mb-4(data-aos="fade-left")
      img(src='@/assets/curso/icon.svg', alt='Imagen decorativa')
      h5 Valores
    
    .row.justify-content-center.align-items-center.mb-5
      .col-lg-4.col-8.mb-4.mb-lg-0
        figure(data-aos="zoom-in")
          img.img-fluid(src="@/assets/curso/temas/tema1/img32.jpg" alt="Icono 1")

      .col-lg-8
        p.mb-5(data-aos="fade-left") Para entender lo que tiene que ver con los valores en el ser humano, acceda al siguiente pódcast, un espacio de reflexión donde se analiza al ser humano como un ser biosocial y la manera en que las libertades individuales se construyen y ejercen dentro de la vida en sociedad. Este contenido permite profundizar en la relación entre ética, convivencia y desarrollo personal, ofreciendo elementos para comprender y fortalecer los sistemas de valores que guían las decisiones cotidianas:
        .BMG4.p-4
          .row.justify-content-center.align-items-center
            .col-lg-4.col-6.mb-4.mb-lg-0
              figure(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema1/img33.svg" alt="Icono 1")
            .col-lg-8
              
                TarjetaAudio.color-acento-contenido.mb-3(
                  texto="Pódcast"
                  :audio="require('@/assets/actividad/audio/Podcast_CF01_33110059_Valores del ser humano.wav')"
                  @audio-hover="mostrarIndicadorTarjetaAudio = false"
              )

    .row.justify-content-center.mb-5
      .col-lg-1.d-none.d-lg-block
        figure(data-aos="zoom-in")
          img.img-fluid(src="@/assets/curso/temas/tema1/img15.svg" alt="Icono 1")
      .col-lg-9
        p.mb-0(data-aos="fade-left") De igual manera, se pueden entender los valores como un gran sistema, los cuales se agrupan en subsistemas. Al respecto, Echeverría (2003) diferencia 12 subsistemas de valores y su comprensión facilita reconocer la diversidad y especificidad de cada uno de ellos. Hay que tener presente que estos valores han aparecido por el esfuerzo de las personas por conquistarse a sí mismas, encontrando:

    .BMG2.px-lg-4.p-4.mb-4
      SlyderB.mb-5(:datos="datosSlyder")
    
    .titulo.mb-4(data-aos="fade-left")
      img(src='@/assets/curso/icon.svg', alt='Imagen decorativa')
      h5 Componentes biopsicosociales
    .row.justify-content-center.mb-4
      .col-lg-1.d-none.d-lg-block
        figure(data-aos="zoom-in")
          img.img-fluid(src="@/assets/curso/temas/tema1/img28.svg" alt="Icono 1")
      .col-lg-11
        p.mb-0(data-aos="fade-left") Reconocer al ser humano en su condición de salud, implica comprenderlo como un todo integral, resultado de la interacción entre factores biológicos, psicológicos y socioculturales. La salud y la enfermedad no dependen únicamente del funcionamiento del cuerpo, sino también de las emociones, el pensamiento, las relaciones y el contexto en el que vive la persona.

    .row.justify-content-center.align-items-center.mb-4
      .col-lg-9.mb-4.mb-lg-0
        p(data-aos="fade-left") El modelo biopsicosocial, propuesto entre las décadas de 1950 y 1960 por George Engel, representó un avance significativo al explicar que los problemas de salud surgen de la interacción de factores biológicos, psicológicos y sociales. Este enfoque plantea que el estado emocional y el entorno social influyen en los procesos biológicos del individuo y, a su vez, estos pueden afectar su comportamiento y sus relaciones sociales, ofreciendo una visión más completa para la atención en salud.
        .cajon.color-primario.p-4.mb-4
          p.mb-0(data-aos="fade-left")  Este modelo enfatiza una visión integral de los factores relacionados con la salud, la enfermedad y la atención. Además, comienza con las teorías / terapias familiares orientadas a la biopsicosocial temprana, luego con la atención médica centrada en la familia y termina con la creación de la terapia médica familiar.
      .col-lg-3.col-6
        figure(data-aos="zoom-in")
          img.img-fluid(src="@/assets/curso/temas/tema1/img29.svg" alt="Icono 1")

    p.mb-4 Su propósito es mostrar cómo las creencias familiares moldean la forma en que las familias se adaptan a las enfermedades y se caracteriza principalmente por:

    .BMG1.px-lg-4.p-4
      .row.justify-content-center.align-items-center.mb-4
        .col-lg-3.col-6.mb-4.mb-lg-0
          figure(data-aos="zoom-in")
            img.img-fluid(src="@/assets/curso/temas/tema1/img30.png" alt="Icono 1")
        .col-lg-9.mb-4.mb-lg-0
          ul.lista-ul
            li
              i.fas.fa-briefcase-medical
              p.mb-0 Unión entre #[i soma] y #[i psique], es decir entre el cuerpo y la mente.
            li
              i.fas.fa-briefcase-medical
              p.mb-0 Relación entre la dinámica familiar y el comportamiento de salud.
            li
              i.fas.fa-briefcase-medical
              p.mb-0 Comprende la condición de salud en términos de la persona, la familia, la relación médico-paciente y el contexto social (McDaniel et al., 1990).
            li
              i.fas.fa-briefcase-medical
              p.mb-0 Permite orientar la atención centrada en la familia de acuerdo con los siguientes niveles:
          .tarjeta-fblanco.p-4.mb-4
            ul.lista-ul.mb-0
              li(data-aos="fade-right") 
                i.lista-ul__vineta
                | Énfasis en la familia y la comunicación con la familia.
              li(data-aos="fade-right") 
                i.lista-ul__vineta
                | Información y asesoramiento involucran a las familias de manera colaborativa.
              li(data-aos="fade-right") 
                i.lista-ul__vineta
                | Sentimiento y apoyo abordan las necesidades emocionales y de salud de la familia.
              li(data-aos="fade-right") 
                i.lista-ul__vineta
                | Evaluación sistémica e intervenciones planificadas permiten ayudar a la familia a desarrollar formas alternativas.
              li(data-aos="fade-right") 
                i.lista-ul__vineta
                | Terapia familiar.
          ul.lista-ul
            li
              i.fas.fa-briefcase-medical
              p.mb-0 Permite ver a la familia como un sistema, en el que existe colaboración enfocada en la promoción de salud.
      p.mb-4 Para clarificar un poco el accionar de los diferentes factores, se presenta la siguiente imagen:
    .row.justify-content-center.align-items-center
      .col-lg-10
        .titulo-sexto.color-primario(data-aos="fade-left")
          h5 Figura 1. 
          span Factores del modelo biopsicosocial
    .row.justify-content-center.align-items-center.mb-4
      .col-lg-10.movil(data-aos="fade-left")
        figure
          img(src='@/assets/curso/temas/tema1/img31_1.svg', alt='Figura 1 que representa por medio de un esquema los tres tipos de factores presentes en el modelo biopsicosocial (biológicos, psicológicos y sociales) y como entre estos se relacionan las necesidades, capacidades y valores con el ser humano.')
      .col-lg-10.desktop(data-aos="fade-left")
        figure
          img(src='@/assets/curso/temas/tema1/img31.svg', alt='Figura 1 que representa por medio de un esquema los tres tipos de factores presentes en el modelo biopsicosocial (biológicos, psicológicos y sociales) y como entre estos se relacionan las necesidades, capacidades y valores con el ser humano.')

</template>

<script>
export default {
  name: 'Tema1',
  data: () => ({
    mostrarIndicador: true,
    indicadorTarjetaFlip: true,
    indicadorTarjetaSlide: true,
    mostrarIndicadorTarjetaAudio: true,
    datosSlyder: [
      {
        titulo: 'Valores básicos',
        texto: 'Alegría, amor, bienestar, capacidad, etc.',
        imagen: require('@/assets/curso/temas/tema1/img16.jpg'),
        // leyendaImagen: 'Leyenda_de_la_imagen',
      },
      {
        titulo: 'Valores religiosos',
        texto: 'Autoridad, caridad, devoción, divinidad o fe.',
        imagen: require('@/assets/curso/temas/tema1/img17.jpg'),
        // leyendaImagen: 'Leyenda_de_la_imagen',
      },
      {
        titulo: 'Valores militares',
        texto: 'Autoridad, deber, disciplina, fidelidad, jerarquía o honor.',
        imagen: require('@/assets/curso/temas/tema1/img18.jpg'),
        // leyendaImagen: 'Leyenda_de_la_imagen',
      },
      {
        titulo: 'Valores morales',
        texto:
          'Altruismo, amistad, autonomía, benevolencia, bien, bondad, compasión, etc.',
        imagen: require('@/assets/curso/temas/tema1/img19.jpg'),
        // leyendaImagen: 'Leyenda_de_la_imagen',
      },
      {
        titulo: 'Valores estéticos',
        texto:
          'Armonía, belleza, claridad, corrección, creatividad, deleite, elegancia, etc.',
        imagen: require('@/assets/curso/temas/tema1/img20.jpg'),
        // leyendaImagen: 'Leyenda_de_la_imagen',
      },
      {
        titulo: 'Valores sociales',
        texto:
          'Antigüedad, cooperación, diligencia, estabilidad, excelencia, éxito, etc.',
        imagen: require('@/assets/curso/temas/tema1/img21.jpg'),
        // leyendaImagen: 'Leyenda_de_la_imagen',
      },
      {
        titulo: 'Valores políticos',
        texto:
          'Autonomía, autoridad, control, democracia, estabilidad, hegemonía, gobernabilidad, etc.',
        imagen: require('@/assets/curso/temas/tema1/img22.jpg'),
        // leyendaImagen: 'Leyenda_de_la_imagen',
      },
      {
        titulo: 'Valores jurídicos',
        texto:
          'Autonomía, claridad, equidad, formalidad, durabilidad, estabilidad, garantías, etc.',
        imagen: require('@/assets/curso/temas/tema1/img23.jpg'),
        // leyendaImagen: 'Leyenda_de_la_imagen',
      },
      {
        titulo: 'Valores económicos',
        texto: 'Beneficio, calidad, comerciabilidad, competitividad, etc.',
        imagen: require('@/assets/curso/temas/tema1/img24.jpg'),
        // leyendaImagen: 'Leyenda_de_la_imagen',
      },
      {
        titulo: 'Valores ecológicos',
        texto:
          'Biodiversidad, conservación, equilibrio renovabilidad, sostenibilidad, etc.',
        imagen: require('@/assets/curso/temas/tema1/img25.jpg'),
        // leyendaImagen: 'Leyenda_de_la_imagen',
      },
      {
        titulo: 'Valores técnicos',
        texto:
          'Aplicabilidad, competencia, corrección, durabilidad, eficacia, eficiencia, fiabilidad, flexibilidad, funcionalidad (en el sentido de que algo funcione), habilidad, innovación, integrabilidad (o composicionalidad), rapidez, robustez, sencillez (de uso), utilidad, versatilidad, etc.',
        imagen: require('@/assets/curso/temas/tema1/img26.jpg'),
        // leyendaImagen: 'Leyenda_de_la_imagen',
      },
      {
        titulo: 'Valores epistémicos',
        texto:
          'Adecuación (empírica), claridad, coherencia, contrastabilidad, fecundidad, generalidad, ingeniosidad, etc.',
        imagen: require('@/assets/curso/temas/tema1/img27.jpg'),
        // leyendaImagen: 'Leyenda_de_la_imagen',
      },
    ],
  }),
  mounted() {
    this.$nextTick(() => {
      this.$aosRefresh()
    })
  },
  updated() {
    this.$aosRefresh()
  },
}
</script>

<style lang="sass"></style>
